import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'
import BenchmarksIcon from '../../assets/images/learn/icons/benchmarks.svg'
import BlogIcon from '../../assets/images/learn/icons/blog.svg'
import BookIcon from '../../assets/images/learn/icons/book.svg'
import HelpCenterIcon from '../../assets/images/learn/icons/helpcenter.svg'
import PodcastIcon from '../../assets/images/learn/icons/podcast.svg'
import { useBuyUrl } from '../../bookUtils'
import Box from '../primitives/Box'
import Button from '../system/Button'
import { HoverMenu, HoverMenuItemProps } from './HoverMenu'

export const learnPages: HoverMenuItemProps[] = [
  {
    icon: BlogIcon,
    title: 'Blog',
    content: 'Insights for software leaders, managers, and engineers',
    href: '/blog/',
  },
  {
    icon: HelpCenterIcon,
    title: 'Help center',
    content: 'Find the answers you need to make the most out of Swarmia',
    href: 'https://help.swarmia.com/',
  },
  {
    icon: PodcastIcon,
    title: 'Podcast',
    content: 'Catch interviews with software leaders on Engineering Unblocked',
    href: '/podcast/',
  },
  {
    icon: BenchmarksIcon,
    title: 'Benchmarks',
    content: 'Find the biggest opportunities for improvement',
    href: '/benchmarks/',
  },
  {
    icon: BookIcon,
    title: 'Book: Build',
    content: 'Read for free, or buy a physical copy or the Kindle version',
    href: '/build/',
  },
]

export const helpCenterLink = {
  text: 'Help Center',
  href: 'https://help.swarmia.com/',
}

const LearnMenu = () => {
  const { cover } = useStaticQuery(graphql`
    query {
      cover: file(
        relativePath: { eq: "images/books/build-cover-cropped.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 719, quality: 90, placeholder: NONE)
          original {
            src
            width
            height
          }
        }
      }
    }
  `)
  return (
    <HoverMenu items={learnPages} width="subMenu">
      <GatsbyImage
        image={cover.childImageSharp.gatsbyImageData}
        alt="Build book cover"
        objectFit="fill"
      />
      <Box position="absolute" top={48} right={48}>
        <BookLinks />
      </Box>
    </HoverMenu>
  )
}

const BookLinks = () => {
  const buyUrl = useBuyUrl()
  return (
    <Box display="flex" flexDirection="column" gap={8} textAlign="right">
      <BookLink href="/build/">Read for free</BookLink>
      <BookLink href={buyUrl}>Buy on Amazon</BookLink>
    </Box>
  )
}

type BookLinkProps = React.PropsWithChildren<{
  href: string
}>
const BookLink = (props: BookLinkProps) => (
  <Button
    variant="leadLink"
    arrow
    color="white"
    hoverProps={{ color: 'white' }}
    href={props.href}
    target={props.href.startsWith('http') ? '_blank' : undefined}
  >
    {props.children}
  </Button>
)

export default LearnMenu
